import FormikTextField from '@ui-components-3/compat/lib/components/FormikTextField'
import PasswordInput from '@ui-components-3/ui/lib/components/PasswordInput'
import { Formik, FormikHelpers } from 'formik'

import TestIds from 'util/TestIds'
import UpdatePasswordSchema from 'schemas/UpdatePasswordSchema'
import useDocumentTitle from 'hooks/useDocumentTitle'
import EntryFormCard from '../EntryFormCard'
import { UpdatePwValues } from 'pages/EntryPage/EntryPage'

export type ExpPwSceneProps = {
  password?: string
  onSubmit: (values: UpdatePwValues, form: FormikHelpers<UpdatePwValues>) => void
  onForgotPassword: () => void
}

const prompt = <>Please create a new password</>
const ExpiredPasswordScene = (props: ExpPwSceneProps): JSX.Element => {
  useDocumentTitle('Login Expired password')
  return (
    <EntryFormCard prompt={prompt} data-testid={TestIds.login.view.expiredPassword}>
      <p className="typography-body self-start pb-4 text-start text-neutral-600">
        All fields marked with asterisks are required*
      </p>
      <Formik
        enableReinitialize
        initialValues={{ oldPassword: props.password || '', password: '', confirmPassword: '' }}
        validationSchema={UpdatePasswordSchema}
        onSubmit={props.onSubmit}
      >
        {(renderProps) => {
          const { dirty, isValid, handleSubmit, values } = renderProps
          return (
            <form onSubmit={handleSubmit} className="flex flex-col items-center gap-4">
              {!props.password && (
                <>
                  <button
                    type="button"
                    className="typography-body text-primary -mb-6 cursor-pointer self-end font-semibold hover:underline"
                    data-testid={TestIds.login.button.forgot}
                    onClick={props.onForgotPassword}
                  >
                    Forgot Password?
                  </button>
                  <FormikTextField
                    fullWidth
                    data-testId={TestIds.security.input.oldPassword}
                    autoComplete="current-password"
                    InputComponent={PasswordInput}
                    VisibilityTogglerProps={{
                      'data-testid': TestIds.security.button.toggleOldPasswordVisibility,
                    }}
                    schema={UpdatePasswordSchema}
                    label={'Existing Password'}
                    name={'oldPassword'}
                  />
                </>
              )}
              <FormikTextField
                fullWidth
                autoComplete="new-password"
                data-testid={TestIds.security.input.password}
                InputComponent={PasswordInput}
                VisibilityTogglerProps={{
                  'data-testid': TestIds.security.button.toggleNewPasswordVisibility,
                }}
                schema={UpdatePasswordSchema}
                label={'New Password'}
                name={'password'}
              />
              <FormikTextField
                fullWidth
                autoComplete="new password"
                data-testid={TestIds.security.input.confirmPassword}
                VisibilityTogglerProps={{
                  'data-testid': TestIds.security.button.toggleConfirmPasswordVisibility,
                }}
                schema={UpdatePasswordSchema}
                InputComponent={PasswordInput}
                label={'Confirm Password'}
                name={'confirmPassword'}
              />
              <button
                className="btn btn-primary mt-4 w-full"
                data-testid={TestIds.security.button.continue}
                disabled={!dirty || !isValid || !values.confirmPassword}
                type="submit"
              >
                Continue
              </button>
            </form>
          )
        }}
      </Formik>
    </EntryFormCard>
  )
}

export default ExpiredPasswordScene
